import { useState } from 'react';
import moment from 'moment';
import { InputText } from 'ui/inputs';
import { FormField } from 'ui/formField';
import MultiSelect from 'core/multiSelect';
import { Button } from 'ui/button';
import { Checkmark } from 'ui/icons';
import { Modal, ModalHeader, ModalBody, ModalFooter, MODAL_SIZES } from 'ui/modal';
import { DateRangePickerWithCollapsibleCalendar } from 'ui/datePicker/DateRangePickerWithCollapsibleCalendar';
import { getNewDate, getMonthsAgo } from 'utils/date';
import { ReportDataSourceTable } from 'modules/reportDataSourceTable';
import { getTimestamp } from '../utils';

// type Props = {
//   createReportModalIsOpen: boolean,
//   closeCreateReportModal: () => void,
//   highLevelMetrics: Object[],
//   highLevelMetricsData: Object[],
//   createNewReport: (Object) => void,
//   loadingHighLevelMetrics: boolean,
//   reportDataSource: Object,
// };

const momentDateOrUnderfined = (date) => (date ? moment(date) : undefined);
export const CreateReportModal = (props) => {
  const [name, setName] = useState('');
  const [reportNameIsValid, setReportNameIsValid] = useState(false);
  const [rangeStart, setRangeStart] = useState(getMonthsAgo(getNewDate(), 1));
  const [rangeEnd, setRangeEnd] = useState(getNewDate());
  const [selectedMetrics, setSelectedMetrics] = useState([]);
  const [selectedMetricsIsValid, setSelectedMetricsIsValid] = useState(false);

  const createReport = () => {
    let validForm = true;
    if (!name) {
      setReportNameIsValid(false);
      validForm = false;
    }
    if (selectedMetrics.length < 1) {
      setSelectedMetricsIsValid(false);
      validForm = false;
    }
    if (!rangeStart || !rangeEnd) {
      validForm = false;
    }
    if (props.reportDataSource?.selectedTypeIdsInModal?.length < 1) {
      validForm = false;
    }
    if (validForm) {
      props.createNewReport({
        name,
        rangeStart,
        rangeEnd,
        selectedMetrics,
      });
    }
  };

  const updateReportName = (reportName) => {
    setName(reportName);
    setReportNameIsValid(true);
  };

  const updateMetricsList = (metrics) => {
    setSelectedMetrics(
      metrics.map((m) => props.highLevelMetricsData.find((hlm) => hlm.enumName === m)),
    );
    setSelectedMetricsIsValid(true);
  };

  const updateRangeStart = (date) => {
    const timestamp = getTimestamp(date);
    setRangeStart(timestamp);
  };

  const updateRangeEnd = (date) => {
    const timestamp = getTimestamp(date);
    setRangeEnd(timestamp);
  };
  const checkReportEntitiesAreValid = () =>
    props.reportDataSource.selectedTypeIdsInModal &&
    props.reportDataSource.selectedTypeIdsInModal.length > 0;

  const isFormValid = () =>
    reportNameIsValid && selectedMetricsIsValid && checkReportEntitiesAreValid();

  const selectedMetricsValuesOnly = selectedMetrics.map((metric) => metric.enumName);

  return (
    <Modal
      isModalOpen={props.createReportModalIsOpen}
      closeIcon={true}
      closeOnDimmerClick={false}
      onClose={props.closeCreateReportModal}
      centered={false}
      size={MODAL_SIZES.LARGE}
    >
      <ModalHeader>Create New Report</ModalHeader>
      <ModalBody scrolling>
        <>
          <FormField labelText="Report Name" isRequired>
            <InputText
              value={name}
              placeholder="Report Name"
              onChange={(val) => updateReportName(val)}
            />
          </FormField>
          <FormField labelText="Report Metrics" isRequired>
            <MultiSelect
              filterPlaceholder={'Filter Metrics'}
              placeholder={props.loadingHighLevelMetrics ? 'Loading metrics...' : 'Select metrics'}
              onChange={(value) => updateMetricsList(value)}
              options={props.highLevelMetrics}
              optionName={'Metric'}
              optionsName={'Metrics'}
              overflowAmount={4}
              value={selectedMetricsValuesOnly}
            />
          </FormField>
          <FormField labelText="Date Range" isRequired>
            <DateRangePickerWithCollapsibleCalendar
              startDate={momentDateOrUnderfined(rangeStart)}
              endDate={momentDateOrUnderfined(rangeEnd)}
              onDateRangeChange={({ startDate, endDate }) => {
                updateRangeStart(startDate);
                updateRangeEnd(endDate);
              }}
              isTimeZonePickerDisabled
              blockFutureDates
            />
          </FormField>
          <FormField labelText="Select Campaigns or Journeys" isRequired>
            <ReportDataSourceTable resetSelectedCampaignsOnMount />
          </FormField>
        </>
      </ModalBody>
      <ModalFooter onClose={() => props.closeCreateReportModal()}>
        <Button onClick={createReport} isDisabled={!isFormValid()}>
          <Checkmark /> Create Report
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default CreateReportModal;
